import Vue from "vue";
import Vuex from "vuex";
import User from "../model/user/User";
import {themeList, themeMap} from "./Themes";
import {sceneryList, sceneryMap} from "./Sceneries";
import TopicManager from "../model/topic/TopicManager";
Vue.use(Vuex)


const state = {
	config: {
		minimize: false,
		mobile: false
	},
	debug: false,
	user: new User(),
	tankHost: "http://smdcourse.sjtu.edu.cn/__tank__",
	host: "/cgdapi",

	//网站名称
	appShortName: "Mitri",
	appName: "媒体与传播学院精品课程",
	//网站版权信息
	copyright: "沪交ICP备20170051 CopyRight 2021© 上海交通大学媒体与传播学院精品课程 版权所有",
	address: "地址:上海市闵行区东川路800号 邮编: 200240",
	//备案信息
	filling: "沪交ICP备20170051",

	breadcrumbs: null,
	sceneryMap: sceneryMap,
	sceneryList: sceneryList,
	themeMap: themeMap,
	themeList: themeList,

	//topic的Pager.
	topicManager: new TopicManager()
}

//read config.minimize from localStorage
if (window.localStorage.config) {
	try {
		let json = JSON.parse(window.localStorage.config)
		state.config.minimize = json.minimize;
	} catch (e) {
		window.localStorage.removeItem("config");
	}
}

//read user from localStorage
if (window.localStorage.user) {
	try {
		let json = JSON.parse(window.localStorage.user)
		state.user.render(json);

	} catch (e) {
		window.localStorage.removeItem("user");
	}
}


const getters = {
	getConfig(state){
		return state.config;
	},
	getMinimize(state) {
		return state.config.minimize;
	}
}

const mutations = {
	toggleMinimize(state){

		state.config.minimize = !state.config.minimize;

		//sync to localStorage.
		window.localStorage.config = JSON.stringify(state.config);
	},
	setMobile(state, mobile){
		state.config.mobile = mobile;
	}
}

const actions = {
	toggleMinimize({commit}){
		commit("toggleMinimize")
	},
	setMobile({commit}, mobile){
		commit("setMobile", mobile)
	}
}

export default new Vuex.Store({
	state,
	getters,
	mutations,
	actions
})



// WEBPACK FOOTER //
// ./src/common/store/index.js